export const SELECT = 'Select';
export const COMPARISON = 'comparison';
export const EMPTY = 'empty';
export const WEEK_OF = 'Week of';

// FILTER OPTIONS
export const AGENT = 'agent';
export const BROKER = 'broker';
export const TEAM = 'team';

// CHART DETAILS
export const PRIMARY_GRAPH_COLOR = 'rgba(0, 94, 162, 1)';
export const PRIMARY_GRAPH_COLOR_COMPARATIVE = 'rgba(0, 94, 162, 0.4)';
export const SECONDARY_GRAPH_COLOR = 'rgba(247, 136, 62, 1)';
export const SECONDARY_GRAPH_COLOR_COMPARATIVE = 'rgba(247, 136, 62, 0.4)';
export const BORDER_WIDTH = 2;
export const POINT_BACKGROUND_COLOR = '#FFF';
export const POINT_RADIUS = 5;

// TIME INTERVALS
export const HOURLY = 'hourly';
export const DAILY = 'daily';
export const WEEKLY = 'weekly';
export const MONTHLY = 'monthly';

// DATE RANGES
export const CURRENT_DAY = 'Current Day';
export const YESTERDAY = 'Yesterday';
export const THIS_WEEK = 'This Week';
export const LAST_7_DAYS = 'Last 7 days';
export const LAST_WEEK = 'Last Week';
export const LAST_14_DAYS = 'Last 14 days';
export const THIS_MONTH = 'This Month';
export const LAST_30_DAYS = 'Last 30 days';
export const LAST_MONTH = 'Last Month';
export const LAST_90_DAYS = 'Last 90 days';
export const THIS_YEAR = 'This Year';
export const LAST_YEAR = 'Last Year';
export const ALL_TIME = 'All Time';

// DATE RANGES VALUES
export const CURRENT_DAY_VAL = 'current_day';
export const YESTERDAY_VAL = 'yesterday';
export const THIS_WEEK_VAL = 'this_week';
export const LAST_7_DAYS_VAL = 'last_7_days';
export const LAST_WEEK_VAL = 'last_week';
export const LAST_14_DAYS_VAL = 'last_14_days';
export const THIS_MONTH_VAL = 'this_month';
export const LAST_30_DAYS_VAL = 'last_30_days';
export const LAST_MONTH_VAL = 'last_month';
export const LAST_90_DAYS_VAL = 'last_90_days';
export const THIS_YEAR_VAL = 'this_year';
export const LAST_YEAR_VAL = 'last_year';
export const ALL_TIME_VAL = 'all_time';

// EVENT TYPES VALUES
export const TEAM_MEMBER = 'Team Member';
export const EMAIL_SENT = 'Email Sent';
export const TEXT_SEMT = 'Text Sent';
export const OUTBOUND_CALLS = 'Outbound Click to Call';
export const COMMENTS = 'Contact Comments';
export const LEAD_ASSIGNED = 'Lead Assigned';
export const EMAIL_RECEIVED = 'Email Received';
export const TEXT_RECEIVED = 'Text Received';
export const INBOUND_CALLS = 'Inbound Call';
export const EMAIL_OPENED = 'Email Opened';
export const EMAIL_CLICKED = 'Email Clicked';
export const EMAIL_SENT_3RD_PARTY = 'Email Sent via 3rd Party';

// DATE-FNS FORMATS
export const HOURLY_FORMAT = 'MMM D H a';
export const DAILY_FORMAT = 'ddd, MMM D, YYYY';
export const WEEKLY_FORMAT = 'MMM D, YYYY';
export const MONTHLY_FORMAT = 'MMM YYYY';

export const ASC = 'asc';
export const DESC = 'desc';
